const routes = [
  {
    path: "/login",
    name: "loginHome",
    meta: {
      isAdmin: false,
    },
    component: () => import("@/views/client/homepage/index.vue"),
  },
];

export default routes;
